/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/350-ligature': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12 13.622v-.002l-.005-6.821-1.992.097H6.067V6.56c0-1.274.091-2.546.269-3.042.123-.343.353-.652.683-.919.322-.261.643-.393.955-.393.262 0 .48.045.647.134.235.134.464.359.682.669.577.82.812 1.038.939 1.131.216.158.477.238.776.238.292 0 .546-.109.757-.324a1.09 1.09 0 00.315-.792c0-.335-.139-.691-.414-1.057-.268-.358-.683-.652-1.232-.875a4.743 4.743 0 00-1.793-.329c-.949 0-1.813.228-2.568.678a4.405 4.405 0 00-1.725 1.863c-.359.728-.333 2.105-.355 3.355H2.038v1.116H4v5.073c0 1.12-.342 1.422-.472 1.583a1.225 1.225 0 01-.944.455H1.98v.878h6.021v-.878h-.105c-1.424 0-1.828-.154-1.828-1.888v-.001l-.001-5.222h2.191c1.163 0 1.43.054 1.491.077.074.028.169.075.204.143.014.026.081.391.081 1.296v3.917c0 .913-.111 1.217-.179 1.319-.145.222-.319.345-.854.358v.879h4.588v-.873c-1.431 0-1.588-.153-1.588-1.505z"/>'
  }
})
